import { Divider, Space, Typography } from 'antd'
import { TitleProps } from 'antd/lib/typography/Title'
import React, { ReactNode } from 'react'

export const Title = (props: { extra?: ReactNode } & TitleProps) => {
  return (
    <div className='ant-typography-title'>
      <Typography.Title {...props}>
        {props.children}
        {props.extra && <Space style={{ float: 'right' }}>{props.extra}</Space>}
      </Typography.Title>
      <Divider style={{ margin: '10px 0px 20px 0px' }} />
    </div>
  )
}
